import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './installed.css';
import Navigation from '../../components/navigation/Navigation';
import { getNewsList } from "../../store/news/actions";
import { formatDate } from "../../helpers/formatterHelper";
import { getCompanies } from "../../store/employee/actions";
import { getLoggedInEmployeeById } from '../../store/employee/actions';
import HeaderProfile from "../../components/HeaderProfile";
import { hideLoading, showLoading } from '../../store/loading-reducer';
import NewsImages from "../../components/news-tiles/NewsImages";
import PortalAlert from '../../components/portalAlert/portalAlert'; 
import { getProjects } from '../../store/projects/actions';

export default function News() {
    const navigate = useNavigate();
    const dispatch = useDispatch(); 
    const { siteUserId, primaryCompanyId } = useSelector(state => state.auth);
    const [filter] = useState({ query: '', companyId: (primaryCompanyId !== undefined && primaryCompanyId !== null ? primaryCompanyId : 0), sort: 6, IsShowPastEvent: false });
    //const initialTodayFilter = primaryCompanyId !== undefined && primaryCompanyId !== 0 ? primaryCompanyId : 0;
    //const { companiesList } = useSelector(state => state.employee);
    //const [projectFilter, setProjectFilter] = useState(initialTodayFilter);
    const { projectsList } = useSelector(state => state.projects);


    useEffect(() => {
        document.title = 'Installed Projects | CWP Team Connect';
        dispatch(getCompanies());
        dispatch(getLoggedInEmployeeById({ id: siteUserId }));
        dispatch(getProjects());
    }, []);

    useEffect(() => {
        dispatch(showLoading());
        dispatch(getNewsList(filter)).unwrap().then(() => {
            dispatch(hideLoading());
        });
    }, [filter]);

    return (
        <div className="directory-wrap news-wrap installed-wrap">
            <div className="drawer-menu-collapse-wrap"></div>
            <Navigation />
            <div className="events-page-wrap">
                <div className="page-inner events-inner">
                    <div className="profile-wrap-outer mobile-show">
                        <HeaderProfile />
                    </div>

                    <div className="events-content-scrollable-wrap">
                        <div className="inner-pages-alert">
                            <PortalAlert />
                        </div>
                        <div className="profile-wrap-outer">
                            <HeaderProfile />
                        </div>
                        <div className="events-header-wrap hrbenefits-header-wrap">

                            <div className="events-header-wrap-inner">
                                <h1 className="page-title news-page-title">Installed Projects</h1>
                                {/*<div className="filter-bars">*/}
                                {/*    <label>*/}
                                {/*        <select className="menu-wrap org-dropdown" name="slct" id="slct" value={projectFilter} onChange={(event) => {*/}
                                {/*            setProjectFilter(event.target.value);*/}
                                {/*            const selectedCompanyId = parseInt(event.target.value);*/}
                                {/*            setFilter({ ...filter, companyId: selectedCompanyId });*/}
                                {/*        }}>*/}
                                {/*            <option value="0">All</option>*/}
                                {/*            {companiesList.map(company => (*/}
                                {/*                <option key={company.id} value={company.id}>{company.abbreviatedName}</option>*/}
                                {/*            ))}*/}
                                {/*        </select>*/}
                                {/*    </label>*/}
                                {/*</div>*/}
                            </div>

                        </div>
                        <div className="events-content-wrap hrbenefits-content-wrap">
                            <div className="events-content-wrap-inner">
                                <div className="events-listing-wrap dashboard-installed-wrap">

                                    {([...projectsList] ?? []).map((projectItem) => (
                                        <a onClick={() => navigate('/installeddetail/' + projectItem.id)}
                                            className={`news-listing-item news-item installed-item light-blue ${projectItem?.pinnedDateTime ? 'pin-list' : ''}`}
                                            key={`projectItem${projectItem.id}`}>
                                            <span className="news-title-wrap">
                                                <span className="news-title-inner">
                                                    <span className="news-day-date">{formatDate(projectItem.createdDate, "MMM dd, y")}</span>
                                                    <span className="news-description">{projectItem.title}</span>
                                                </span>
                                            </span>
                                            <span className="pin-img-wrap">
                                                <span className="news-image-wrap">
                                                    {projectItem?.projectMedias?.length > 0 && (() => {
                                                        const mediaItem = projectItem.projectMedias?.[0]?.mediaItem;  
                                                        if (mediaItem) {
                                                            return (
                                                                <div className="video-event-wrap" key={`media_${mediaItem[0]?.id}`}>
                                                                    <NewsImages mediaItem={projectItem.projectMedias?.[0]?.mediaItem} />
                                                                </div>
                                                            );
                                                        }
                                                    })()}
                                                </span>
                                            </span>
                                        </a>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}